export default __webpack_public_path__ + "static/media/logoRealizandoEscolhasDesktop.bf0d5d13.svg";